import React from 'react';

export const PdfIcon = () => {
  return (
    <>
      <svg focusable="false" className="icon icon--pdf" role="presentation" viewBox="0 0 60 60">
        <path stroke="currentColor" strokeWidth="2.35" strokeMiterlimit="10" fill="none" d="M41.8,1.2H19.5c-2.2,0-4,1.8-4,4v49.5c0,2.2,1.8,4,4,4h33.8c2.2,0,4-1.8,4-4V17c0-0.8-0.3-1.5-0.9-2.1L44,2.1
        C43.4,1.6,42.6,1.2,41.8,1.2z"></path>
        <polyline stroke="currentColor" strokeWidth="2.35" strokeLinecap="round" strokeMiterlimit="10" fill="none" points="43,1.8 43,16.2 56.9,16.2 "></polyline>
        <path stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeMiterlimit="10" fill="#FFFFFF" d="M38,43.9H6c-1.7,0-3-1.3-3-3V25c0-1.7,1.3-3,3-3h32c1.7,0,3,1.3,3,3v15.9C41,42.5,39.7,43.9,38,43.9z"></path>
        <path fill="currentColor" d="M16,29.1c-0.4-0.5-0.9-0.8-1.4-1C14.2,28,13.4,28,12.2,28H9v9.9h2v-3.7h1.3c0.9,0,1.6,0,2.1-0.1c0.4-0.1,0.7-0.2,1-0.5
          c0.3-0.2,0.6-0.6,0.8-1c0.2-0.4,0.3-0.9,0.3-1.5C16.6,30.2,16.4,29.6,16,29.1z M14.3,31.8c-0.2,0.2-0.4,0.4-0.6,0.5
          c-0.3,0.1-0.8,0.2-1.6,0.2H11v-2.8h1c0.7,0,1.2,0,1.4,0.1c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.5,0.3,0.9
          C14.5,31.3,14.5,31.6,14.3,31.8z"></path>
        <path fill="currentColor" d="M26.2,30.7c-0.2-0.6-0.5-1.2-0.9-1.6c-0.4-0.4-0.9-0.7-1.5-0.9C23.3,28,22.7,28,21.9,28h-3.7v9.9H22
          c0.7,0,1.3-0.1,1.8-0.2c0.6-0.2,1.1-0.5,1.4-0.8c0.5-0.4,0.8-1,1.1-1.8c0.2-0.6,0.3-1.3,0.3-2.1C26.5,32.1,26.4,31.3,26.2,30.7z
          M24.3,34.7c-0.1,0.4-0.3,0.8-0.5,1c-0.2,0.2-0.5,0.3-0.8,0.4c-0.2,0.1-0.7,0.1-1.2,0.1h-1.5l0,0v-6.6h0.9c0.8,0,1.4,0,1.6,0.1
          c0.4,0.1,0.7,0.2,0.9,0.5c0.2,0.2,0.4,0.5,0.6,1c0.1,0.4,0.2,1,0.2,1.8C24.5,33.7,24.4,34.3,24.3,34.7z"></path>
        <polygon fill="currentColor" points="35,29.6 35,28 28.3,28 28.3,37.9 30.3,37.9 30.3,33.7 34.4,33.7 34.4,32 30.3,32 30.3,29.6 			"></polygon>
      </svg>
    </>
  )
}

export const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M6.667 13.333 10 10m0 0 3.333 3.333M10 10v7.5M16.667 13.98A4.167 4.167 0 0 0 14.167 6.25h-1.05A6.667 6.667 0 1 0 3.333 13.917"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2 4h12M5.333 4V2.667a1.333 1.333 0 0 1 1.334-1.334h2.666a1.333 1.333 0 0 1 1.334 1.334V4m2 0v9.333a1.333 1.333 0 0 1-1.334 1.334H4.667a1.333 1.333 0 0 1-1.334-1.334V4h9.334Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M10 3 4.5 8.5 2 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);